import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'healthfully-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Healthfully',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 8004592003,
  email: 'support@healthfully.io',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/healthfully/index.js